"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterDrawerContextExample = exports.FilterDrawerContext = exports.FilterDrawer = exports.CalendarActionsDrawerContextExample = exports.CalendarActionsDrawerContext = exports.CalendarActionsDrawer = exports.DefaultDrawer = void 0;
var material_1 = require("@mui/material");
var react_1 = __importDefault(require("react"));
var providers_1 = require("../../providers");
var constants_1 = require("../../shared/constants");
var enums_1 = require("../../shared/enums");
var il_button_1 = require("../il-button/il-button");
var il_button_common_1 = require("../il-button/il-button.common");
var common_components_1 = require("../event-timeoff-form/common.components");
var il_temporary_drawer_1 = require("./il-temporary-drawer");
var ChildElement = function (_a) {
    var onClose = _a.onClose;
    return (react_1.default.createElement(il_button_1.ILButton, { onClick: function () {
            onClose && onClose();
        } }, "Some children"));
};
exports.DefaultDrawer = {
    clickableComponent: react_1.default.createElement(il_button_1.ILButton, null, "Click Here"),
    children: react_1.default.createElement(ChildElement, null),
};
function FilterDrawer(_a) {
    var students = _a.students, activities = _a.activities, _b = _a.emptyStudentText, emptyStudentText = _b === void 0 ? (react_1.default.createElement(material_1.Typography, { variant: enums_1.TypographyVariantEnum.BODY1 }, "No Active Students")) : _b, _c = _a.emptyActivityText, emptyActivityText = _c === void 0 ? (react_1.default.createElement(material_1.Typography, { variant: enums_1.TypographyVariantEnum.BODY1 }, "No Activity Type")) : _c, props = __rest(_a, ["students", "activities", "emptyStudentText", "emptyActivityText"]);
    var theme = (0, material_1.useTheme)();
    var _d = react_1.default.useState(props.selectedStudent || students[0]), selected = _d[0], setSelected = _d[1];
    var _e = react_1.default.useState(props.selectedActivities || activities), selectedActivities = _e[0], setSelectedActivities = _e[1];
    function selectStudent(student) {
        setSelected(student);
    }
    function toggleActivity(activity) {
        var act = selectedActivities.find(function (a) { return a.activity === activity.activity; });
        if (act) {
            setSelectedActivities(selectedActivities.filter(function (a) { return a.activity !== act.activity; }));
        }
        else {
            setSelectedActivities(__spreadArray(__spreadArray([], selectedActivities, true), [activity], false));
        }
    }
    function onApply(selectedStudent, selectedActivities) {
        if (selectedActivities.length === 0) {
            selectedActivities = activities;
        }
        props.onApply(selectedStudent, selectedActivities);
        setSelected(selectedStudent);
        setSelectedActivities(selectedActivities);
    }
    function ChildrenElement(_a) {
        var onClose = _a.onClose;
        var hasStudents = students && students.length > 0;
        return (react_1.default.createElement(material_1.Box, { sx: {
                p: '1.5rem',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                height: '100%',
            } },
            react_1.default.createElement(material_1.Box, null,
                react_1.default.createElement(material_1.Typography, { variant: enums_1.TypographyVariantEnum.H3, sx: { my: 0, mb: '1.25rem' } }, "Filters"),
                react_1.default.createElement(material_1.Typography, { variant: enums_1.TypographyVariantEnum.H4, sx: { my: 0 } }, "Student"),
                react_1.default.createElement(material_1.Divider, { sx: { mt: '0.5rem' } }),
                react_1.default.createElement(material_1.List, { dense: true, sx: { my: 0 } }, hasStudents ? (students.map(function (student) { return (react_1.default.createElement(material_1.ListItem, { disablePadding: true, key: student.guid, "aria-label": "menuitem ".concat(student.firstName) },
                    react_1.default.createElement(material_1.ListItemButton, { onClick: function () { return selectStudent(student); }, selected: (selected === null || selected === void 0 ? void 0 : selected.guid) === student.guid, sx: {
                            color: (selected === null || selected === void 0 ? void 0 : selected.guid) === student.guid ? 'primary.main' : 'text.primary',
                            '& .MuiListItemText-root .MuiTypography-root': {
                                fontSize: '1rem',
                            },
                            '& .MuiAvatar-root': {
                                width: '1.5rem',
                                height: '1.5rem',
                            },
                            '& .MuiListItemAvatar-root': {
                                minWidth: '2rem',
                            },
                            p: '0.5rem',
                        } },
                        react_1.default.createElement(common_components_1.RenderStudentItem, { student: __assign(__assign({}, student), { avatar: (selected === null || selected === void 0 ? void 0 : selected.guid) === student.guid
                                    ? theme.palette.primary.main
                                    : student.avatar }) })))); })) : (react_1.default.createElement(material_1.ListItem, { disablePadding: true, "aria-label": "menuitem empty" }, emptyStudentText))),
                react_1.default.createElement(material_1.Box, { sx: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' } },
                    react_1.default.createElement(material_1.Typography, { variant: enums_1.TypographyVariantEnum.H4, sx: { my: 0 } }, "Activity Type"),
                    react_1.default.createElement(material_1.Button, { variant: enums_1.ButtonVariantEnum.TEXT, onClick: function () { return setSelectedActivities([]); } }, "Clear All")),
                react_1.default.createElement(material_1.Divider, { sx: { mt: '0.5rem' } }),
                react_1.default.createElement(material_1.Box, null,
                    (!activities || !(activities === null || activities === void 0 ? void 0 : activities.length)) && (react_1.default.createElement(material_1.ListItem, { disablePadding: true, "aria-label": "menuitem empty" }, emptyActivityText)),
                    activities.map(function (activity) { return (react_1.default.createElement(material_1.Box, { key: activity.activity, sx: {
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            px: '0.5rem',
                            cursor: 'pointer',
                        }, onClick: function () { return toggleActivity(activity); } },
                        react_1.default.createElement(material_1.Box, { sx: { display: 'flex', alignItems: 'center' } },
                            react_1.default.createElement(material_1.Checkbox, { edge: "start", checked: !!selectedActivities.find(function (s) { return s.activity === activity.activity; }), size: "small" }),
                            react_1.default.createElement(material_1.Typography, { variant: enums_1.TypographyVariantEnum.BUTTON, sx: { ml: '0.8125rem', color: 'primary.main' } }, activity.icon),
                            react_1.default.createElement(material_1.Typography, { variant: enums_1.TypographyVariantEnum.BUTTON, sx: { ml: '0.3125rem' } }, activity.activity)),
                        react_1.default.createElement(material_1.Typography, { variant: enums_1.TypographyVariantEnum.BUTTON, color: "secondary" }, activity.count))); }))),
            react_1.default.createElement(material_1.Box, { sx: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '1rem',
                    mt: '1rem',
                    alignItems: 'stretch',
                    '& .MuiButton-root': { width: '100%' },
                } },
                react_1.default.createElement(il_button_1.ILButton, { variant: enums_1.ButtonVariantEnum.CONTAINED, onClick: function () {
                        onApply(selected, selectedActivities);
                        onClose && onClose();
                    } }, "Apply"),
                react_1.default.createElement(il_button_1.ILButton, { variant: enums_1.ButtonVariantEnum.TEXT, onClick: function () {
                        onApply(students[0], activities);
                        onClose && onClose();
                    } }, "Clear All"))));
    }
    return (react_1.default.createElement(il_temporary_drawer_1.ILTemporaryDrawer, __assign({ showClose: true, clickableComponent: react_1.default.createElement(il_button_common_1.FiltersButton, null) }, props),
        react_1.default.createElement(ChildrenElement, null)));
}
exports.FilterDrawer = FilterDrawer;
function FilterDrawerContext(props) {
    var ctx = (0, providers_1.usePlannerContext)();
    return (react_1.default.createElement(FilterDrawer, __assign({}, props, { activities: ctx.activities, students: __spreadArray([constants_1.allStudentUser], ctx.students, true), selectedActivities: ctx.activities.filter(function (ac) {
            return ctx.selectedActivities.includes(ac.activity);
        }), selectedStudent: ctx.students.find(function (st) { return st.guid === ctx.selectedStudent; }), onApply: function (selectedStudent, selectedActivities) {
            ctx.selectActivities(selectedActivities.map(function (a) { return a.activity; }));
            ctx.selectStudent(selectedStudent.guid);
        } })));
}
exports.FilterDrawerContext = FilterDrawerContext;
function ShowData() {
    var ctx = (0, providers_1.usePlannerContext)();
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { "data-testid": "selected-activities" }, JSON.stringify(ctx.selectedActivities)),
        react_1.default.createElement("div", { "data-testid": "selected-student" }, JSON.stringify(ctx.selectedStudent))));
}
function FilterDrawerContextExample(_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (react_1.default.createElement(material_1.Box, { sx: { m: 2, p: 2 } },
        react_1.default.createElement(providers_1.PlannerProvider, { defaultContext: {
                students: props.students,
                activities: props.activities,
            } },
            react_1.default.createElement(FilterDrawerContext, __assign({}, props)),
            react_1.default.createElement(ShowData, null),
            children)));
}
exports.FilterDrawerContextExample = FilterDrawerContextExample;
function CalendarActionsDrawer(_a) {
    var clickTimeOff = _a.clickTimeOff, clickAddEvent = _a.clickAddEvent, clickReschedule = _a.clickReschedule, _b = _a.showTimeoff, showTimeoff = _b === void 0 ? true : _b, _c = _a.showAddEvent, showAddEvent = _c === void 0 ? true : _c, _d = _a.showReschedule, showReschedule = _d === void 0 ? true : _d, props = __rest(_a, ["clickTimeOff", "clickAddEvent", "clickReschedule", "showTimeoff", "showAddEvent", "showReschedule"]);
    var theme = (0, material_1.useTheme)();
    var buttonSx = {
        p: '0.7rem',
        fontSize: '1rem',
        '& .MuiButton-startIcon svg': {
            width: '1.625rem',
            height: '1.625rem',
            color: (0, material_1.alpha)(theme.palette.text.primary, 0.8),
        },
    };
    function ChildrenElement(_a) {
        var onClose = _a.onClose;
        function toggleTimeOff() {
            clickTimeOff && clickTimeOff();
            onClose && onClose();
        }
        function toggleAddEvent() {
            clickAddEvent && clickAddEvent();
            onClose && onClose();
        }
        function toggleReschedule() {
            clickReschedule && clickReschedule();
            onClose && onClose();
        }
        return (react_1.default.createElement(material_1.Box, { sx: {
                p: '1.5rem',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-start',
                alignItems: 'baseline',
                gap: '1.5rem',
            } },
            showTimeoff && (react_1.default.createElement(il_button_common_1.TimeOffButton, { sx: __assign(__assign({}, il_button_common_1.TimeOffButtonArgs.sx), buttonSx), onClick: toggleTimeOff })),
            showAddEvent && (react_1.default.createElement(il_button_common_1.AddEventButton, { sx: __assign(__assign({}, il_button_common_1.AddEventButtonArgs.sx), buttonSx), onClick: toggleAddEvent })),
            showReschedule && (react_1.default.createElement(il_button_common_1.RescheduleButton, { sx: __assign(__assign({}, il_button_common_1.RescheduleButtonArgs.sx), buttonSx), onClick: toggleReschedule }))));
    }
    return (react_1.default.createElement(il_temporary_drawer_1.ILTemporaryDrawer, __assign({ showClose: true, anchor: enums_1.AnchorEnum.RIGHT, clickableComponent: react_1.default.createElement(il_button_common_1.CalendarActionsButton, null) }, props),
        react_1.default.createElement(ChildrenElement, null)));
}
exports.CalendarActionsDrawer = CalendarActionsDrawer;
function CalendarActionsDrawerContext(_a) {
    var clickTimeOff = _a.clickTimeOff, clickAddEvent = _a.clickAddEvent, clickReschedule = _a.clickReschedule, props = __rest(_a, ["clickTimeOff", "clickAddEvent", "clickReschedule"]);
    var ctx = (0, providers_1.usePlannerContext)();
    return (react_1.default.createElement(CalendarActionsDrawer, __assign({ clickTimeOff: ctx.toggleTimeoff, clickAddEvent: ctx.toggleAddEvent, clickReschedule: ctx.toggleReschedule }, props)));
}
exports.CalendarActionsDrawerContext = CalendarActionsDrawerContext;
function ShowToggles() {
    var ctx = (0, providers_1.usePlannerContext)();
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { "data-testid": "open-reschedule" }, ctx.openReschedule && react_1.default.createElement(react_1.default.Fragment, null, "Open Reschedule")),
        react_1.default.createElement("div", { "data-testid": "open-add-event" }, ctx.openAddEvent && react_1.default.createElement(react_1.default.Fragment, null, "Open Add Event")),
        react_1.default.createElement("div", { "data-testid": "open-time-off" }, ctx.openTimeoff && react_1.default.createElement(react_1.default.Fragment, null, "Open Time Off"))));
}
function CalendarActionsDrawerContextExample(_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (react_1.default.createElement(providers_1.PlannerProvider, null,
        react_1.default.createElement(CalendarActionsDrawerContext, __assign({}, props)),
        react_1.default.createElement(ShowToggles, null),
        children));
}
exports.CalendarActionsDrawerContextExample = CalendarActionsDrawerContextExample;
